<i class="pi pi-question-circle question-style cursor-pointer" (click)="showInfo()"></i>
